module.exports = __webpack_public_path__ + "media/reskin-images/cohorts-c9311dd1.svg";